import { Injectable, OnInit } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class CommonService {

    public token: string;

    constructor(private httpService: HttpService) {
    }

    getHolidaysList(startDate, endDate) {
        const body = {
            'appLang': 'fr',
            'startDate': startDate,
            'endDate': endDate
        };
        // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getholidaylist', body)
        return this.httpService.post('/hradmin/getHolidayList', body)
    }

    getWorkdaysList(empid, startDate, endDate, availabilityType) {
        const body = {
            'appLang': 'fr',
            'startDate': startDate,
            'endDate': endDate,
            'employeeID': empid,
            'availabilityType': availabilityType
        };
        // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getworkdayslist', body)
        return this.httpService.post('/hradmin/getWorkDaysList', body)
    }

    getCertificate(certificateId) {
        // return this.httpService.get('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getcertificate/' + certificateId)
        return this.httpService.get('/hradmin/getCertificateHRA/' + certificateId)
    }

    getIrregularityByAbsenceId(absenceID) {
        const body = {
            'appLang': 'fr',
            'absenceID': absenceID
        };
        return this.httpService.post('/hradmin/getIrregularityDetailByAbsenceID', body);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/common.service.ts